import { all, takeEvery, put, select } from 'redux-saga/effects';
import actions from './actions';
import siteConfig from '@iso/config/site.config';
import { notification } from '@iso/components';
import invoiceActions from '../ventas/actions';
const { GET_VENTAS } = invoiceActions;
const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
  headers: {
    Authorization: localStorage.getItem('access_token'),
    AuthId: localStorage.getItem('id_token'),
  }
}

export function* addOp(action) {
  const { Auth } = yield select();
  action.data.vendedor = Auth.id_token;
  let ULRDestino = "api/ventas/op/";
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: { ...action.data, esContadorPrueba: process.env.NODE_ENV === 'development' ? true : false },
    method: metodo,
  });
  if (res.data.success) {
    notification('success', res.data.msg);
    yield put({ type: actions.GET_OPS, query: `producto=${action.data.producto}&producida=false&etapa=0&nuevaEtapa=${action.data.nuevaEtapa}` });
    yield put({ type: GET_VENTAS, query: "producida=false&enProduccion=false&aprobado=true" });
  } else {
    notification('error', res.data.msg);
  }
}

export function* edtiOPS(action) {
  const { Auth } = yield select();
  action.data.vendedor = Auth.id_token;
  let ULRDestino = "api/ventas/op/" + action.data._id;
  let metodo = "PUT";
  delete action.data.vendedor;
  delete action.data._id;
  const res = yield gaxios.request({
    url: ULRDestino,
    data: action.data,
    method: metodo,
  });
  if (res.data.success) {
    notification('success', res.data.msg);
    let query = action.query ? action.query : "currentPage=1&pageSize=50&producida=false";
    if (action.data.producto) {
      query = "producto=" + action.data.producto._id + "&producida=false";
    }
    console.log(action);
    if (action.data.paseOpcional?.length) {
      yield put({ type: actions.PASS_OPTIONS, data: action.data.paseOpcional, accion: true });
    }
    if (!action.data.paseDeEtapa) {
      console.log("sin pase de etapa")
      yield put({ type: actions.GET_OPS, query });
    } else {
      console.log("con pase de etapa")

      yield put({ type: actions.UPDATE_ETAPA, payload: res.data.doc });
      yield put({ type: actions.GET_OPS, query });
    }
  } else {
    notification('error', res.data.msg);
  }
}

export function* getOP(action) {
  const query = action.query ? `?${action.query}` : ""
  let ULRDestino = "api/ventas/user/" + action.data.id + query;
  const res = yield gaxios.request({
    url: ULRDestino,
  });
  if (res.data.success) {
    yield put({ type: actions.SET_OPS, payload: res.data.opes })
  } else {
    notification('error', res.data.msg);
  }
}

export function* getOPS(action) {
  const query = action.query ? `?${action.query}` : "";
  let params = new URLSearchParams(action.query).get("proceso");
  let ULRDestino = "api/ventas/op/" + query;
  const res = yield gaxios.request({
    url: ULRDestino,
  });
  if (res.data.success) {
    yield put({ type: actions.SET_OPS, payload: res.data.opes, currentProceso: params })
    if (res.data.paginationInfo) {
      yield put({
        type: actions.SET_PAGINATION_INFO,
        payload: res.data.paginationInfo,
      });
    }
  } else {
    notification('error', res.data.msg);
  }
}

export function* deleteOP(action) {
  const res = yield gaxios.request({
    url: 'api/ventas/op/' + action.id,
    method: 'DELETE',
  });

  if (res.data.success) {
    yield put({ type: actions.DELETED_OP, payload: action.id });
    notification('success', res.data.msg);
  } else {
    notification('error', res.data.msg);
  }
}

export function* passToOptions(action) {
  let ULRDestino = "api/ventas/opciones/";
  let metodo = "PUT";
  const res = yield gaxios.request({
    url: ULRDestino,
    data: { accion: action.accion, ventas: action.data },
    method: metodo,
  });
  if (res.data.success) {
    notification('success', "Se ha pasado las ventas a procesos opcionales");
  } else {
    notification('error', res.data.msg);
  }
}

export function* addNotasProduccion(action) {
  let ULRDestino = `api/orden-produccion/notas/${action.id}`;
  const res = yield gaxios.request({
    url: ULRDestino,
    data: action.data,
    method: "PUT",
  });
  if (res.data.success) {
    notification('success', "Nota de producción agrega con éxito");
    yield put({ type: actions.GET_OPS, query: "" });
  } else {
    notification('error', res.data.msg);
  }
}

export function* confirmarInventario(action) {
  let ULRDestino = `api/orden-produccion/inventario/`;
  const res = yield gaxios.request({
    url: ULRDestino,
    data: action.data,
    method: "POST",
  });
  if (res.data.success) {
    notification('success', "Se ha registrado en el inventario con éxito");
    yield put({ type: actions.UPDATE_OP_ESTADO, delete: res.data.idOP });
  } else {
    notification('error', res.data.msg);
  }
}

export default function* () {
  yield all([
    takeEvery(actions.ADD_OP, addOp),
    takeEvery(actions.GET_OP, getOP),
    takeEvery(actions.GET_OPS, getOPS),
    takeEvery(actions.PASS_OPTIONS, passToOptions),
    takeEvery(actions.EDIT_OPS, edtiOPS),
    takeEvery(actions.DELETE_OP, deleteOP),
    takeEvery(actions.ADD_NOTAS_PRODUCCION, addNotasProduccion),
    takeEvery(actions.CONFIRMAR_INVENTARIO, confirmarInventario),
    
  ]);
}
